// generated from 1_548 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const firstUsedSpecificAppFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("first_used_specific_app_filter"),
  comparison_key: z.enum([
    "4", // 865 (55.88%)
    "6", // 409 (26.42%)
    "5", // 183 (11.82%)
    "3", // 91 (5.88%)
  ]),
  display_name: z.object({
    id: common.objectId,
    value: z.string(),
  }),
  // undefined: 560 (36.18%), defined 988 (63.82%)
  raw_value: z
    .union([
      // number samples: 735 (74.39%)
      // integer: 717 (97.55%)
      // avg: 6.27, min: 0, max: 110
      z.number().min(0),
      // string samples: 253 (25.61%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 1_274 (82.30%)
    // integer: 1_249 (98.04%)
    // avg: 8.44, min: 0, max: 110
    z.number().min(0),
    // string samples: 274 (17.70%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
